import { selectPartnerName } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';
import { TRUCKSTOP_PARTNER_NAME } from '@/partners/truckstop';

export const testId = 'slogan';
export const truckstopTestId = 'truckstop-slogan';

export function Slogan(): JSX.Element {
    const partnerName = useAppSelector(selectPartnerName);
    const isTruckstop = partnerName === TRUCKSTOP_PARTNER_NAME;

    if (isTruckstop) {
        return (
            <p
                data-testid={truckstopTestId}
                className='text font-bold uppercase text-center pt-2'
            >
                Conditional approval in {'<'} 2 mins
                <br />
                for free
            </p>
        );
    }

    return (
        <p data-testid={testId} className='text font-bold text-sm'>
            Get an instant response.
            <br />
            No Impact on credit score.
        </p>
    );
}
